import * as React from 'react';
import type { SVGProps } from 'react';
const MoveIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.54545 10.5298L12 8.07528L14.4545 10.5298M14.4545 15.4389L12 17.8935L9.54545 15.4389M21 19.5298L21 6.43892C21 5.78794 20.7414 5.16361 20.2811 4.7033C19.8208 4.24298 19.1964 3.98438 18.5455 3.98438L5.45454 3.98438C4.80356 3.98438 4.17924 4.24298 3.71892 4.7033C3.2586 5.16361 3 5.78794 3 6.43892L3 19.5298C3 20.1808 3.2586 20.8051 3.71892 21.2655C4.17924 21.7258 4.80356 21.9844 5.45455 21.9844L18.5455 21.9844C19.1964 21.9844 19.8208 21.7258 20.2811 21.2655C20.7414 20.8051 21 20.1808 21 19.5298Z"
      stroke="#9099A5"
      strokeWidth="1.63636"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default MoveIcon;
